"use client";
import { Link } from "@/navigation";
import { LinkedinLogo, TiktokLogo } from "@phosphor-icons/react";
import React from "react";
import { contactObj } from "@/lib/contacts";
import { useTranslations } from "next-intl";

const FollowUs = ({ className, textClass }: { className?: string; textClass?: string }) => {
	const t = useTranslations();
	return (
		<div className={`mt-6 flex  ${className}`}>
			<p className="text-sm font-semibold ">{t("base.followOn")}</p>
			<SocialList className={textClass}></SocialList>
		</div>
	);
};
export const SocialList = ({ className }: { className?: string }) => {
	return (
		<div className="right-content ml-10 flex items-center  gap-5">
			<Link href={contactObj.Youtube} target="_blank">
				<i className={`ri-youtube-fill text-lg text-white ${className}`}></i>
			</Link>
			<Link href={contactObj.Linkedin} target="_blank">
				<i className={`ri-linkedin-fill text-lg text-white ${className}`}></i>
			</Link>
			<Link href={contactObj.FaceBook} target="_blank">
				<i className={`ri-facebook-fill text-lg text-white ${className}`}></i>
			</Link>
			<Link href={contactObj.instagram} target="_blank">
				<i className={`ri-instagram-line text-lg text-white ${className}`}></i>
			</Link>
		</div>
	);
};

export default FollowUs;
